import { useCallback } from "react"
import { useSignal } from "@preact/signals-react"
import { getSubmit, postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"
import { useToast } from "@hooks"
import { REPORT_ACTIONS } from "../@constants"
import { useReportBackendApiPath } from "Pages/ReportsAlerts/Reports/@hooks/index"


export default function useReportActions(reportExecutionID, reportName) {
	const { showToast } = useToast()
	const actionInProgress = useSignal([])
	const { backendUrl } = useReportBackendApiPath()

	const handleMultiAction = useCallback(action => {
		actionInProgress.value = [...actionInProgress.value, action]
		showToast.promise(getSubmit(`${backendUrl}/multi/download`, {
			idReportExecution: reportExecutionID, isExport: action === REPORT_ACTIONS.MULTI_EXPORT
		}), {
			onSuccess: res => {
				if (!res.length)
					showToast.warning('Data not found')
				else res.forEach((link, idx) => setTimeout(() => {
					window.location.href = link
				}, (idx + 1) * 1000))
			},
			onFinish: () => actionInProgress.value = [
				...actionInProgress.value.filter(item => item !== action)
			]
		})
	}, [reportExecutionID])

	const handleMultiRatingAction = useCallback(() => {
		actionInProgress.value = [...actionInProgress.value, REPORT_ACTIONS.MULTI_REPORT]
		showToast.promise(getSubmit(`${BACKEND_APIS.REPORTS_MULTI_DOWNLOAD_RATING}`, {
			idReportExecution: reportExecutionID
		}), {
			onSuccess: res => {
				if (!res.length)
					showToast.warning('Data not found')
				else res.forEach((link, idx) => setTimeout(() => {
					window.location.href = link
				}, (idx + 1) * 1000))
			},
			onFinish: () => actionInProgress.value = [
				...actionInProgress.value.filter(item => item !== REPORT_ACTIONS.MULTI_REPORT)
			]
		})
	}, [reportExecutionID])

	const handleCallAction = useCallback((action, officeID = null) => showToast.confirm(`Are you sure you want to ${action} the report titled ${reportName}?`, {
		onSubmit: () => {
			actionInProgress.value = [...actionInProgress.value, action]
			showToast.promise(postSubmit(`${BACKEND_APIS.INTERMEDIARY}/check/executions/report/force`, {
				reportExecutionID: reportExecutionID, officePickupID: officeID
			}), {
				onFinish: () => actionInProgress.value = [
					...actionInProgress.value.filter(item => item !== action)
				]
			})
		}
	}), [reportExecutionID])

	return {
		actionInProgress: actionInProgress.value,

		handleMultiAction,
		handleMultiRatingAction,
		handleCallAction
	}
}